export const blueprintKitchenData7 = {
	id: '',
	version: null,
	baseVersion: null,
	createdBy: '',
	createDate: '',
	material: {
		countertop: {
			key: 'chiseledsmoky',
			thickness: 1.25
		},
		surround: {
			key: 'stackedstone/graphite',
			type: 'stone',
			override: true
		}
	},
	fuelchoice: 'ng',
	design: {
		islands: {
			defaultIslandId: null,
			children: []
		},
		countertops: [],
		dimensions: {
			children: []
		},
		notifications: {
			children: [],
			_metadata: {
				state: 0,
				counts: {
					total: 0,
					info: 0,
					warn: 0,
					error: 0,
					critical: 0
				}
			}
		}
	},
	promotionalSkus: {
		children: [],
		_metadata: {
			totalSkus: 0,
			totalAdjustment: 0
		}
	},
	notes: {
		children: []
	},
	skuAnnotations: {
		children: []
	},
	artifacts: {},
	quoteId: '',
	isFinalized: false,
	tax: 0,
	description: '',
	kitchenLayout: '',
	layout: 'custom',
	location: 'Not Set'
}
